import { twMerge } from 'tailwind-merge'
import { clsx } from 'clsx'

/** Visual variant for the Badge pill: `'default'` | `'success'` | `'warning'` | `'danger'` | `'info'`. */
export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info'

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-gray-100 text-gray-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-yellow-100 text-yellow-700',
  danger: 'bg-red-100 text-red-700',
  info: 'bg-blue-100 text-blue-700',
}

interface BadgeProps {
  variant?: BadgeVariant
  children: React.ReactNode
  className?: string
}

/** Small coloured pill label. Accepts a `variant` prop that maps to Tailwind colour classes. */
export function Badge({ variant = 'default', children, className }: BadgeProps) {
  return (
    <span
      className={twMerge(
        clsx(
          'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
          variantClasses[variant],
          className
        )
      )}
    >
      {children}
    </span>
  )
}
